import React from "react";

interface LanguageSelectProps {
  value: string;
  onChange: (language: string) => void;
  languages?: Record<string, string>;
  className?: string;
  id?: string;
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ value, onChange, languages, className = "", id = "language-select" }) => {
  if (!languages) {
    return null;
  }

  return (
    <select
      id={id}
      className={`w-full border border-stone-300 rounded-lg px-4 py-2 text-lg text-stone-700 bg-white cursor-pointer transition-all duration-200 focus:outline-none focus:border-azure-600 focus:ring-1 focus:ring-azure-600 hover:border-stone-700 dark:bg-stone-650 dark:text-white dark:border-zeus-900 ${className}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {Object.entries(languages).map(([label, value]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelect;
